var exports = {
  "k": "container__p5uBad",
};

module.exports = exports;
